export const proxyService = {
    getUsername,
    generateAsisKey,
    hasAsisKey,
    deleteAsisKey
}

function getUsername() {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include', // <- c'est ça qui inclut les cookies
    };

    return fetch(`${process.env.VUE_APP_API_PROXY_URL}/auth/username`, requestOptions)
        .then(response => {
            if (!response.ok) {
                // ici tu attrapes les 401/403/etc.
                redirectURL(response);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            return data
        })
        .catch(error => {
            redirectURL(error)
        })
}

function generateAsisKey() {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include', // <- c'est ça qui inclut les cookies
    };

    return fetch(`${process.env.VUE_APP_API_PROXY_URL}/auth/asisKey`, requestOptions)
        .then(response => {
            if (!response.ok) {
                // ici tu attrapes les 401/403/etc.
                redirectURL(response);
            }
            return response.json();
        })
        .then(data => {
            return data
        })
        .catch(error => {
            redirectURL(error)
        })
}

function hasAsisKey() {
    const requestOptions = {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include', // <- c'est ça qui inclut les cookies
    };

    return fetch(`${process.env.VUE_APP_API_PROXY_URL}/auth/asisKey`, requestOptions)
        .then(response => {
            if (!response.ok) {
                // ici tu attrapes les 401/403/etc.
                redirectURL(response);
            }
            return response.json(); // ou response.text() selon ton API
        })
}

function deleteAsisKey() {
    const requestOptions = {
        method: 'DELETE',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include', // <- c'est ça qui inclut les cookies
    };
    return fetch(`${process.env.VUE_APP_API_PROXY_URL}/auth/asisKey`, requestOptions)
        .then(response => {
            if (!response.ok) {
                // ici tu attrapes les 401/403/etc.
                redirectURL(response);
            }
        })

}

async function redirectURL(response) {

    const data = await response.json(); // récupère le JSON de la réponse

    if (response.status === 401 && data?.loginUrl) {
        const currentUrl = window.location.href;

        localStorage.setItem('redirectAfterLogin', currentUrl);

        const loginUrl = data.loginUrl + "&state=" + encodeURIComponent(currentUrl);
        window.location.href = loginUrl;
    }

}



